if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.enableConfetti = this.dataset.enableConfetti === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.submitForm();
      }

      submitForm() {
        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.variantIdInput?.value) {
          this.handleErrorMessage(window.variantStrings.unavailable);
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.classList.add('loading');
        if (this.submitButtonText) this.submitButtonText.textContent = 'Adding...';
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        config.body = formData;

        fetch('/cart/add.js', config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            const sectionsResponse = await fetch('/?sections=cart-drawer,cart-icon-bubble', {
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
              },
            });

            if (!sectionsResponse.ok) throw new Error('Failed to refresh cart sections.');

            const sections = await sectionsResponse.json();

            if (this.cart && sections['cart-drawer']) {
              const parsedDrawer = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
              const freshDrawer = parsedDrawer.querySelector('cart-drawer');

              if (freshDrawer) {
                this.cart.innerHTML = freshDrawer.innerHTML;
                this.cart.classList.remove('is-empty');
                this.cart.classList.add('active');
                if (typeof this.cart.open === 'function') {
                  if (this.enableConfetti) {
                    setTimeout(() => this.cart.open(this.submitButton), 700);
                  } else {
                    this.cart.open(this.submitButton);
                  }
                }
              }
            }

            const cartBubble = document.getElementById('cart-icon-bubble');
            if (cartBubble && sections['cart-icon-bubble']) {
              const parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              const freshBubble = parsedBubble.getElementById('cart-icon-bubble');
              if (freshBubble) cartBubble.innerHTML = freshBubble.innerHTML;
            }

            this.error = false;
            this.triggerConfetti();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (!this.error) this.submitButton.removeAttribute('disabled');
            if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          let warmMessage = errorMessage;
          const lowerMessage = errorMessage.toLowerCase();
          
          if (lowerMessage.includes('select') && (lowerMessage.includes('variant') || lowerMessage.includes('option'))) {
            warmMessage = "Almost there! Pick your color above and we'll spin it your way 🎯";
          } else if (
            lowerMessage.includes('stock') || 
            lowerMessage.includes('limit') || 
            lowerMessage.includes('exceed') || 
            lowerMessage.includes('only') ||
            lowerMessage.includes('can\'t add') || 
            lowerMessage.includes('cannot add') ||
            (lowerMessage.includes('all') && lowerMessage.includes('in your cart'))
          ) {
            const matches = errorMessage.match(/\b\d+\b/);
            const qty = matches ? matches[0] : null;
            if (qty) {
              warmMessage = `You're a power-fidgeter! Only ${qty} left — grab them before someone else does.`;
            } else {
              warmMessage = "You're a power-fidgeter! Only a few left — grab them before someone else does.";
            }
          }
          this.errorMessage.textContent = warmMessage;
        }
      }

      triggerConfetti() {
        if (!this.enableConfetti || !this.submitButton) return;

        const buttonRect = this.submitButton.getBoundingClientRect();
        const buttonCenterX = buttonRect.left + buttonRect.width / 2;
        const buttonCenterY = buttonRect.top + buttonRect.height / 2;

        if (typeof window.confetti === 'function') {
          window.confetti({
            particleCount: 120,
            spread: 75,
            origin: {
              x: buttonCenterX / window.innerWidth,
              y: buttonCenterY / window.innerHeight,
            },
          });
          return;
        }

        const burstCount = 24;
        const fragment = document.createDocumentFragment();
        const colors = ['#22c55e', '#3b82f6', '#f59e0b', '#ec4899', '#a855f7'];

        for (let i = 0; i < burstCount; i += 1) {
          const piece = document.createElement('span');
          piece.className = 'pdp-confetti-piece';
          piece.style.left = `${Math.random() * 100}%`;
          piece.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
          piece.style.setProperty('--pdp-confetti-x', `${(Math.random() - 0.5) * 180}px`);
          piece.style.setProperty('--pdp-confetti-r', `${Math.random() * 720}deg`);
          piece.style.animationDelay = `${Math.random() * 80}ms`;
          fragment.appendChild(piece);
        }

        const burst = document.createElement('span');
        burst.className = 'pdp-confetti-burst';
        burst.setAttribute('aria-hidden', 'true');
        burst.style.left = `${buttonCenterX + window.scrollX}px`;
        burst.style.top = `${buttonCenterY + window.scrollY}px`;
        burst.appendChild(fragment);
        document.body.appendChild(burst);

        window.setTimeout(() => burst.remove(), 1000);
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
